<template>
	<modal ref="modal" size="modal-xl">
		<template #title>Transactions</template>
		<template #body>
			<div v-if="txnRecords && txnRecords.length > 0" class="table-responsive">
				<table class="table table-borderless table-striped table-vcenter">
					<thead class="text-center border-bottom">
						<tr>
							<th class="fs-xs">Action</th>
							<th class="fs-xs">Followup Status</th>
							<th class="fs-xs">Txn_id</th>
							<th class="fs-xs">Date Requested</th>
							<th class="fs-xs">Fullname</th>
							<th class="fs-xs">Email</th>
							<th class="fs-xs">Mobile</th>
							<th class="fs-xs">Course Code</th>
							<th class="fs-xs">Course</th>
							<th class="fs-xs">Amount</th>
							<th class="fs-xs">MOP</th>
							<th class="fs-xs">Status</th>
						</tr>
					</thead>
					<tbody class="fs-sm text-nowrap">
						<tr v-for="txnRecord in txnRecords" :key="txnRecord.counter">
							<td>
								<button
									@click="$emit('fetchTxnRequest', txnRecord.counter)"
									type="button"
									class="btn btn-alt-primary btn-sm"
								>
									Follow Up
								</button>
							</td>
							<td>{{ txnRecord.follow_status }}</td>
							<td>{{ txnRecord.txnid }}</td>
							<td>{{ txnRecord.date_created }}</td>
							<td>{{ txnRecord.fullname }}</td>
							<td>{{ txnRecord.email }}</td>
							<td>{{ txnRecord.mobile }}</td>
							<td>{{ txnRecord.codetype }}</td>
							<td>{{ txnRecord.course }}</td>
							<td>{{ txnRecord.amount }}</td>
							<td>{{ txnRecord.mop }}</td>
							<td>{{ txnRecord.status }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</template>
		<template #footer>
			<button @click="toggleModal" type="button" class="btn btn-alt-secondary">
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { ref } from 'vue'

export default {
	props: {
		txnRecords: {
			type: Object,
			default: null,
		},
	},
	emits: ['fetchTxnRequest'],
	setup() {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		return {
			modal,
			toggleModal,
		}
	},
}
</script>
